<template>
  <div>  
    <div class="d-flex flex-stack flex-wrap">
      <div class="page-title d-flex flex-column me-3 mt-3"> 
          <h1 class="d-flex text-gray-800 fw-bolder my-1 fs-3">
            General Company Settings
          </h1>  
          <ul class="breadcrumb breadcrumb-dot fw-bold text-gray-600 fs-7 my-1"> 
              <li class="breadcrumb-item text-gray-600">
                <a href="#" class="text-gray-600 text-hover-primary">
                  <router-link :to="{ name: 'Home' }">Home</router-link>
                </a>
              </li> 
              <li class="breadcrumb-item text-gray-600"><router-link :to="{ name: 'Settings' }">Settings</router-link></li>  
              <li class="breadcrumb-item text-gray-600"><router-link :to="{ name: 'CompanySettings' }">Company Settings</router-link></li>
          </ul> 
      </div>  
        <div class="d-flex align-items-center py-1">
            <router-link to="/CompanySettings">
                <button type="button" class="btn btn-light shadow-sm btn-arrow-left border border-gray-400 me-3">
                    <span class="ms-2 fs-7"> Return back to Settings </span>
                </button>
            </router-link>
        </div> 
    </div>
    <div class="content flex-row-fluid mt-4" id="kt_content">
      <RequiredField></RequiredField>
      <div class="card card-xxl-stretch">
        <div class="card-header">
          <div class="card-title">
            <ul class="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder">
              <li class="nav-item">
                <a class="nav-link" href="#company_ganeral" @click="this.activeView = 'General'" :class="{'text-active-primary active' :activeView == 'General'}" data-bs-toggle="tab" target="_self">
                  General
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div v-if="this.activeView == 'General'" class="tab-pane fade show active" id="company_general" role="tabpanel">
          <div class="row">
              <div class="tab-content" id="myTabContent">
                <div class="card card-xxl-stretch tab-pane fade show active" id="kt_accounting_1" role="tabpanel">
                  <div class="p-10">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="card card-xxl-stretch mb-6 bg-lighten border border-gray-300">
                                <div class="card-body pb-0">
                                    <form id="kt_ecommerce_settings_general_form"
                                        class="form fv-plugins-bootstrap5 fv-plugins-framework">                                
                                        <div class="fv-row mb-7 row">
                                          <div class="col-lg-12">
                                            <div class="form-check">
                                              <input class="form-check-input fs-6 fw-bold form-label mt-3" type="checkbox" id="isAllowRegistrationNumberDuplication" v-model="form.is_allow_registration_number_duplication">
                                              <label class="fs-6 fw-bold form-label mt-3" for="isDefault">
                                                Is Allow Registration Number Duplication
                                              </label>
                                            </div>
                                          </div>
                                          <div class="col-lg-12">
                                            <label class="fs-6 fw-bold form-label mt-3">
                                                Tawk Property ID
                                            </label>
                                            <input type="text" class="form-control" placeholder="" name="name" v-model="form.tawk_property_id"> 
                                          </div>
                                          <div class="col-lg-12">
                                            <label class="fs-6 fw-bold form-label mt-3">
                                                Tawk Widget ID
                                            </label>
                                            <input type="text" class="form-control" placeholder="" name="name" v-model="form.tawk_widget_id"> 
                                          </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div> 
                      <div class="d-grid gap-2 "> 
                          <button type="button" class="btn btn-lg btn-primary " @click="this.saveData()" data-kt-indicator="on">
                              <span class="svg-icon svg-icon-2"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path opacity="0.3" d="M10 18C9.7 18 9.5 17.9 9.3 17.7L2.3 10.7C1.9 10.3 1.9 9.7 2.3 9.3C2.7 8.9 3.29999 8.9 3.69999 9.3L10.7 16.3C11.1 16.7 11.1 17.3 10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                              <path d="M10 18C9.7 18 9.5 17.9 9.3 17.7C8.9 17.3 8.9 16.7 9.3 16.3L20.3 5.3C20.7 4.9 21.3 4.9 21.7 5.3C22.1 5.7 22.1 6.30002 21.7 6.70002L10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                              </svg>
                              </span>
                                <strong v-if="!this.isProgressing"> Save Company General Settings </strong> 
                                  <span class="indicator-progress" v-if="this.isProgressing">
                                      Saving Data... <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                  </span> 
                          </button>
                      </div>
                    </div> 
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div> 
  </div> 
</template>

<script>
import axios from 'axios';
export default {
  name: "GeneralCompanySettings",
  data() {
    return {
      isProgressing: false,
      form: {
        list_date_range: 10,
        is_allow_registration_number_duplication: false,
        consolidation_rate_type: 0,
        consolidation_currency: null,
        tawk_widget_id: null,
        tawk_property_id: null
      },
      activeView: "General"
    };
  },
  methods: {
    getData() {
      const params = {
        session_id: this.$getUser().session_id
      };
      axios.post('/api/SystemParameters/GetGeneralSystemParameters', params, {'Content-Type': 'application/json'})
      .then((response) => {   
          this.form = { 
            list_date_range: response.data.list_date_range,
            is_allow_registration_number_duplication: response.data.is_allow_registration_number_duplication == 1 ? true : false,
            consolidation_rate_type: response.data.consolidation_rate_type,
            consolidation_currency: response.data.consolidation_currency,
            tawk_property_id: response.data.tawk_property_id,
            tawk_widget_id: response.data.tawk_widget_id,
          };   
      })
      .catch(function (error) {
          console.error(error);
          this.$swal("Failed", "Data could not be saved..Please refresh the page and try again..!", "error");   
      });
    },
    saveData(){
      this.isProgressing = true;
      const params = this.form;
      params.session_id = this.$getUser().session_id;
      params.is_allow_registration_number_duplication = params.is_allow_registration_number_duplication == true ? 1 : 0;
      const that = this;     
      axios.post('/api/SystemParameters/UpdateGeneralSystemParameters', params, {'Content-Type': 'application/json'})
      .then(() => { 
        this.$swal("Success", "Data saved succesfully..!", 'success');
        this.getData();
      })
      .catch(function (error) {
          console.error(error);
          this.$swal("Failed", "Data could not be saved..Please refresh the page and try again..!", "error");   
      })
      .finally(function () { 
          setTimeout(() => {
              that.isProgressing = false;
          }, 500);
      }); 
    }
  },
  mounted() { 
    this.getData();
  }
}; 
</script>